import { Identificator } from './custom-types';
import { Adres } from './adres';
import { KontoBankowe } from './konto-bankowe';
import { Organizacja } from './organizacja';
import { NotyfikacjeBeneficjenta } from './notyfikacje-beneficjenta';
import { Slownik } from './slownik';
import { Plec } from '../enums/plec.enum';
import { RodzajDokumentu } from '../enums/rodzaj-dokumentu.enum';
import { BeneficjentRole } from './beneficjent-role';
import { ApplicationContext } from '../../core/services/application-context.service';
import { Application } from './application';

export class Beneficjent {
  id!: Identificator | null;
  imie!: string | null;
  drugieImie!: string | null;
  nazwisko!: string | null;
  obywatelstwo!: Slownik | null;
  pesel!: string | null;
  dataUrodzenia!: Date | null;
  rodzajDokumentu!: RodzajDokumentu | null;
  nrDokumentu!: string | null;
  plec!: Plec | null;
  stanCywilny!: Slownik | null;
  telefon1!: string | null;
  telefon2!: string | null;
  email!: string | null;
  notyfikacjeBeneficjenta!: NotyfikacjeBeneficjenta | null;
  adres!: Adres | null;
  czyAdresKorespondencyjny!: boolean | null;
  adresKorespondencyjny!: Adres | null;
  kontoBankowe!: KontoBankowe | null;
  organizacje!: Organizacja[] | null;
  wybranaOrganizacjaId?: number | null;
  czyZweryfikowanyEmail!: boolean | null;
  akceptacjaRegulaminu!: boolean | null;
  akceptacjaRODO!: boolean | null;
  zmianaRegulaminu!: boolean | null;
  zweryfikowaneDane!: boolean | null;
  ostatnioSkaldaneWnioski!: Array<Application> | null;
  role!: Array<BeneficjentRole> | null;
  applicationContextOnInit!: ApplicationContext | null;
}
